import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-ipd-payment-modal',
  templateUrl: './ipd-payment-modal.component.html',
  styleUrls: ['./ipd-payment-modal.component.css']
})
export class IpdPaymentModalComponent implements OnInit {
  lead_id;payment_type;
  PaymentLinkForm: FormGroup;
  copypaymentlink:any;
  show_copy:boolean=false;
  loading:boolean = false;
  constructor(public dialogRef: MatDialogRef<IpdPaymentModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder) { 
    this.lead_id = data.lead_id;
    this.payment_type = data.type;
     console.log(this.lead_id)

    this.PaymentLinkForm = this.formBuilder.group({
      'patient_name' : [null, Validators.required],
      'mobile' : [null, Validators.required],
      'amount' : [null, Validators.required],
      'description' : [null, Validators.required],
      'leadid' : [null, Validators.required],
      'ipdid' : [null, Validators.required],
      'lab_lead_id' : [null],
      'payment_type' : this.payment_type
    })
    
  }

  copyToClipboard(element) {
    element.select();
    document.execCommand('copy');
    this.sharedapi.presentToast('Link copied to clipboard.');
  }

  ngOnInit(): void {
    this.getIpdDetails();
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: '' });
  }
  getIpdDetails(){
    let d = {lead_id:this.lead_id}
    this.leadapi.getIpdDetails(d).subscribe((data:any) =>{
      // console.log("ipd",data);
      if(data.status)
      {
        let patientID = data.lead.glamyo_patient_id;
        let patient = data.data.patient;
        let hospital = data.data.hospitalName;
        let bdName = data.data.bd_name;
        let details = 'PatientID: '+patientID+', PatientName: '+patient+', Hospital: '+hospital+', BdName: '+bdName;
        this.PaymentLinkForm.controls['patient_name'].setValue(data.lead.lead_name);
        this.PaymentLinkForm.controls['mobile'].setValue(data.lead.mobile);
        this.PaymentLinkForm.controls['description'].setValue(details);
        this.PaymentLinkForm.controls['leadid'].setValue(this.lead_id);
        this.PaymentLinkForm.controls['ipdid'].setValue(data.data.id);
      }
      else{
        if(data.error_type!='no')
        this.sharedapi.presentToast('Error Occured');
      }
    },
    error => {
        this.sharedapi.checkError(error);
    });
  }

  sendPaymentLink(){
    this.loading = true;
    if (this.PaymentLinkForm.invalid) {
      this.loading = false;
      return;
    }
    let formData = this.PaymentLinkForm.value
    
    this.leadapi.share_payment_link(formData).subscribe((data:any) =>{
      this.loading = false;
      if (data.data.hasOwnProperty("error")) {
        this.sharedapi.presentToast(data.data.error.description);
      }else{
        this.sharedapi.presentToast("Payment Link Sent Successfully!");
        this.show_copy = true;
        
        this.copypaymentlink = data.data.short_url;
        //$("#copypaymentlink").val(data.data.short_url);
        
        //this.closeDialog();
      }
    },
    error => {
        this.sharedapi.checkError(error);
    });
  }
  


}

